import React, { useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ApiKeyRow = (props) => {
	const { label, apiKey, description } = props,
		[copied, setCopied] = useState(false);

	const copyKey = () => {
		if (!navigator.clipboard) {
			toast.error("Clipboard is not available in this browser");
			return;
		}
		navigator.clipboard.writeText(apiKey).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		}).catch(() => toast.error("Unable to copy the API key"));
	}

	return (
		<div className='apiKeyRow'>
			<h3>{label}</h3>
			<p className='apiKeyDescription'>{description}</p>
			<div className='apiKeyValue'>
				<code>{apiKey}</code>
				<Button className='cta autoWidth' color='primary' type='button' onClick={copyKey}>
					{copied ? "Copied" : "Copy"}
				</Button>
			</div>
		</div>
	);
}

/**
 * Shown after a Drupal store is saved. The AI Assistant key is pasted into the
 * ConversionBox AI Assistant Drupal module to finish onboarding.
 */
const DrupalConnectGuide = (props) => {
	const { storeURL, searchApiKey, aiAssistantApiKey } = props,
		[redirect, setRedirect] = useState(false);

	if (redirect) {
		return <Navigate to="/user/dashboard" replace />
	}

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>Connect Your Drupal Site</h2>
						</Col>
					</Row>
				</div>
			</section>
			<section className='shopifyAppInstallationGuide mt-5'>
				<div className='container'>
					<Row className='justify-content-center'>
						<Col xs={12} lg={8}>
							<div className='shopifyInstructionManual'>
								<h3>{storeURL}</h3>
								<p className='installMaunalText'>
									<span>Store saved. Keep these API keys, they are shown here for setup.</span>
								</p>

								{aiAssistantApiKey &&
									<ApiKeyRow
										label="AI Assistant API key"
										apiKey={aiAssistantApiKey}
										description="Install the ConversionBox AI Assistant module on your Drupal site, then paste this key at Configuration &rarr; Web services &rarr; ConversionBox AI Assistant and press Connect store."
									/>
								}

								{searchApiKey &&
									<ApiKeyRow
										label="Search API key"
										apiKey={searchApiKey}
										description="Use this key for ConversionBox Search on your Drupal site."
									/>
								}

								{aiAssistantApiKey &&
									<div className='drupalInstallSteps'>
										<h3>Finish AI Assistant setup</h3>
										<ol>
											<li>Install and enable the <strong>ConversionBox AI Assistant</strong> module on your Drupal site.</li>
											<li>Go to <strong>Configuration &rarr; Web services &rarr; ConversionBox AI Assistant</strong>.</li>
											<li>Paste the AI Assistant API key and press <strong>Connect store</strong>.</li>
											<li>On the <strong>Catalog source</strong> tab, choose how your product pages are built, then save.</li>
										</ol>
									</div>
								}

								<div className='d-flex justify-content-center mt-5'>
									<Button className='cta autoWidth' color='primary' type='button' onClick={() => setRedirect(true)}>
										Go to dashboard
									</Button>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</section>
		</>
	);
}

export default DrupalConnectGuide;
